import {Component, inject, OnInit, signal} from '@angular/core';
import {NzCardModule} from 'ng-zorro-antd/card';
import {NzTabsModule} from 'ng-zorro-antd/tabs';
import {FormControl, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {NzInputModule} from 'ng-zorro-antd/input';
import {NzFormModule} from 'ng-zorro-antd/form';
import {NzButtonModule} from 'ng-zorro-antd/button';
import {ActivatedRoute, Router} from '@angular/router';
import {SessionService} from '../../core/session.service';
import {environment} from '../../../environments/environment';
import {LAST_URL} from '../../models/storageKeys';
import {user$} from '../../core/session';

@Component({
  selector: 'app-login',
  imports: [
    NzFormModule, NzTabsModule, NzCardModule, ReactiveFormsModule, NzInputModule, NzButtonModule
  ],
  templateUrl: './login.component.html',
  styleUrl: './login.component.less'
})
export class LoginComponent implements OnInit {


  sess = inject(SessionService);
  actRoute = inject(ActivatedRoute);
  router = inject(Router);
  ssoUrl = `${environment.ssoUrl}?r=${window.location.href}/`;
  form = new FormGroup({
    userId: new FormControl(null, Validators.required),
    password: new FormControl(null, Validators.required)
  });
  user$ = user$;
  loading = signal(false);
  redirecting = signal(false);

  constructor() {
  }

  async ngOnInit() {
    const token = this.actRoute.snapshot.params['token'];
    if (token) {
      this.loading.set(true);
      await this.sess.ssoSignIn(token);
    }
  }

  async continue() {
    await this.router.navigateByUrl(localStorage.getItem(LAST_URL ?? '/dashboard'))
  }

  ssoSignIn() {
    this.redirecting.set(true);
    window.location.replace(this.ssoUrl);
  }

  async signIn() {
    if (this.form.valid) {
      const {userId, password} = this.form.value;
      this.sess.passwordSignIn(userId, password);
    }
  }

  async signOut() {
    await this.sess.signOut();
  }
}
